import { ProductDetail } from '@api/catalog';

import { colors } from '@scripts/gds';
import { getBooleanValue } from '@scripts/helpers';

const AttributesItem = ({ productItem }: { productItem: ProductDetail }) => {
    return (
        <span>
            {productItem.attributes?.map(attribute => (
                <>
                    <span>{attribute.name}</span>
                    {': '}
                    <span css={{ color: colors.textMainBlack }}>
                        {attribute.values
                            .map(({ value }) =>
                                attribute.type === 'boolean' ? getBooleanValue(Boolean(value)) : value
                            )
                            .join(', ')}
                    </span>
                    {'; '}
                </>
            ))}
        </span>
    );
};

export default AttributesItem;
